import React, { useState, useEffect } from "react";
import { Dropdown, Table, Button } from "react-bootstrap";
import { GetRaisedConcernsNetworkForSidebar } from "../../api/api";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

function Concern() {
  const [invoicesData, setInvoicesData] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log(invoicesData, "get raise concern");
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const data = await GetRaisedConcernsNetworkForSidebar();
        if (Array.isArray(data.dataItems)) {
          setInvoicesData(data.dataItems);
        } else {
          setInvoicesData([]);
        }
      } catch (err) {
        console.error("Failed to load invoice data", err);
        setInvoicesData([]);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, []);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedData = [...invoicesData].sort((a, b) => {
      const valA = a[key]?.toString().toLowerCase() || "";
      const valB = b[key]?.toString().toLowerCase() || "";
      if (valA < valB) return direction === "asc" ? -1 : 1;
      if (valA > valB) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setInvoicesData(sortedData);
  };

  return (
    <div>
      {" "}
      <div className="container mt-4">
        <div className="netwrok_table_main_content">
          <h5 className="fw-bold my-3">Concerns Cases</h5>
          <div className="table-responsive">
            <Table className="bg-white text-center border-0 network_table">
              <thead style={{ backgroundColor: "#EEF4FF" }}>
                <tr className="text-dark fw-semibold table_th_border">
                  {/* <th className="border-start" style={{ whiteSpace: "nowrap" }}>
                    Customer Name
                  </th> */}
                  <th style={{ whiteSpace: "nowrap", cursor: "pointer" }} onClick={() => handleSort("srN_No")}>
                    AA Number {sortConfig.key === "srN_No" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                  </th>
                  <th style={{ whiteSpace: "nowrap", cursor: "pointer" }} onClick={() => handleSort("created_Date")}>
                    Created Date {sortConfig.key === "created_Date" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                  </th>
                  <th style={{ whiteSpace: "nowrap", cursor: "pointer" }} onClick={() => handleSort("time")}>
                    Time {sortConfig.key === "time" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                  </th>
                  <th style={{ whiteSpace: "nowrap", cursor: "pointer" }} onClick={() => handleSort("remarkCategory")}>
                    Remark By {sortConfig.key === "remarkCategory" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                  </th>
                  <th style={{ whiteSpace: "nowrap", cursor: "pointer" }} onClick={() => handleSort("remarkIssue")}>
                    Remark Issue {sortConfig.key === "remarkIssue" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                  </th>
                  <th style={{ whiteSpace: "nowrap" }}>Image</th>

                </tr>
              </thead>
              <tbody>
                {invoicesData.length > 0 ? (
                  invoicesData.map((item, index) => (
                    <tr
                      key={index}
                      className="text-center border-bottom network_td_item"
                    >
                      {/* <td className="border-start align-middle">
                       {item.customerName}
                      </td> */}
                      <td className="align-middle">{item.srN_No}</td>
                      <td className="align-middle">
                        {item.created_Date ?? "--"}
                      </td>
                      <td className="align-middle">{item.time ?? "--"} </td>
                      {/* <td className="align-middle">{item.status ?? "--"}</td> */}
                      <td className="align-middle">
                        {item.remarkCategory ?? "--"}
                      </td>
                      <td className="align-middle">
                        {item.remarkIssue ?? "--"}
                      </td>
                      <td className="align-middle border-end">
                        {item.image?.toLowerCase().endsWith('.pdf') ? (
                          <a
                            href={item.image}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            style={{ color: 'red', textDecoration: 'none' }}
                          >
                            <PictureAsPdfIcon style={{ fontSize: 40 }} />
                          </a>
                        ) : (
                          <a
                            href={item.image}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                          >
                            <img
                              src={item.image}
                              alt="Concern"
                              style={{
                                width: '60px',
                                height: '40px',
                                objectFit: 'cover'
                              }}
                            />
                          </a>
                        )}
                      </td>

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      {loading ? "Loading..." : "No data available"}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Concern;
